import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M4.01 6.03l7.51 3.22-7.52-1 .01-2.22m7.5 8.72L4 17.97v-2.22l7.51-1M2.01 3L2 10l15 2-15 2 .01 7L23 12 2.01 3z"
}), 'SendOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SendOutlined.js
// module id = 5969
// module chunks = 2